if (!customElements.get("nmn-search-results")) {
  const fillerWords = new Set([
    "a", "an", "and", "are", "can", "do", "does", "for", "how", "i", "is",
    "it", "my", "of", "our", "should", "the", "to", "we", "you", "your",
  ]);

  customElements.define("nmn-search-results", class extends HTMLElement {
    static normalise(value) {
      return value.normalize("NFKC").toLowerCase()
        .replace(/[’']/g, "")
        .replace(/[^\p{L}\p{N}+.]+/gu, " ")
        .replace(/\.(?!\d)|(?<!\d)\./g, " ")
        .replace(/(\d)\s+(mg|mcg|g|ml)\b/g, "$1$2")
        .replace(/\s+/g, " ").trim();
    }

    static scoreTitle(query, title) {
      const normalQuery = this.normalise(query);
      const normalTitle = this.normalise(title);
      if (!normalQuery || !normalTitle) return 0;
      const queryWords = [...new Set(normalQuery.split(" ").filter((word) => !fillerWords.has(word)))];
      const titleWords = [...new Set(normalTitle.split(" ").filter((word) => !fillerWords.has(word)))];
      if (!queryWords.length || !titleWords.length) return 0;
      if (normalQuery === normalTitle) return 100;
      const matches = queryWords.filter((word) => titleWords.includes(word));
      if (matches.length < 2) return 0;
      // Missing negation or a different strength must not become a top match.
      const qualifiers = (words) => words.filter((word) => /\d/.test(word) || ["not", "no", "without"].includes(word));
      if (qualifiers(queryWords).some((word) => !titleWords.includes(word)) ||
          qualifiers(titleWords).some((word) => !queryWords.includes(word))) return 0;
      const coverage = 70 * matches.length / queryWords.length + 30 * matches.length / titleWords.length;
      const phraseBonus = titleWords.join(" ").includes(queryWords.join(" ")) ? 3 : 0;
      // Reserve 100 for an exact title match.
      return Math.min(99, coverage + phraseBonus);
    }

    static selectResult(query, items) {
      const ranked = items.map((item) => ({ item, score: this.scoreTitle(query, item.dataset.searchTitle) }))
        .sort((a, b) => b.score - a.score);
      const [first, second] = ranked;
      if (!first || first.score < 90 || (second && first.score - second.score < 10)) return null;
      return first.item;
    }

    connectedCallback() {
      // Wait for children when this element is parsed into a live document.
      queueMicrotask(() => {
        if (this.isConnected) this.rank();
      });
    }

    rank() {
      const top = this.querySelector("[data-search-top]");
      const list = this.querySelector("[data-search-top-list]");
      const kind = this.querySelector("[data-search-top-kind]");
      if (!top || !list || !kind) return;
      list.replaceChildren();
      top.hidden = true;
      if (this.hasAttribute("data-ranking-disabled")) return;
      const items = [...this.querySelectorAll("[data-search-group] [data-search-item]")];
      const winner = this.constructor.selectResult(this.dataset.query || "", items);
      if (!winner) return;
      // Keep the original result and its position in the regular results.
      const copy = winner.cloneNode(true);
      copy.removeAttribute("data-search-item");
      copy.removeAttribute("id");
      copy.querySelectorAll("[id]").forEach((element) => element.removeAttribute("id"));
      list.append(copy);
      kind.textContent = winner.dataset.searchKind;
      top.hidden = false;
    }
  });
}
